import Search from './search.js';
window.searchFrom = new Search('from');
window.searchTo = new Search('to');



// WEBPACK FOOTER //
// ./public/scripts/webpack/entry.js